import { Button, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Splitter, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSendRateConfirmation extends Layout {
    buttonCancel: Button;
    buttonSend: Button;
    buttonSendLater: Button;
    horizontalspacer1: HorizontalSpacer;
    imageCarrierVerification: Image;
    imageError: Label;
    imageHighwayLogo: Image;
    imageWarning: Label;
    labelHeaderTitle: Label;
    labelImageVerification: Label;
    panelHeader: Panel;
    panelPreview: Panel;
    panelProgress: Panel;
    panelRateConData: Panel;
    sourceSendRateConfirmation: DataSource;
    sourceTemplateRateConfirmation: DataSource;
    splitterRateConf: Splitter;
    textboxCC: Textbox;
    textboxCarrierId: Textbox;
    textboxComment: Textbox;
    textboxContactName: Textbox;
    textboxDefaultTemplate: Textbox;
    textboxEmailAddress: Textbox;
    textboxSubject: Textbox;
}
